import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MustMatch } from '../../../../../src/_helpers/must-match.validator';
import { ApiSgsService } from '../api/api-sgs.service';



@Component({
  selector: 'app-sgsregister',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  
  constructor(
  private formBuilder: FormBuilder,
  private router: Router,
  public ApiSgsService: ApiSgsService
  ) { }
  showDetail = false;
  membertype = 0;
  ismembertypevalid = false;

  MyForm = this.formBuilder.group({
      name: ['', Validators.required],
      sgsmembertype: ['', Validators.required],
      customerid: [''],
      pass: ['', [Validators.required,Validators.minLength(6)]],
      username: ['', Validators.required ],
      repass: ['', Validators.required ],
      email: ['', [Validators.required,Validators.email]],
      phonenumber: ['', [Validators .required,Validators.minLength(10),Validators.pattern('^[0-9]*$')]],
      description: [''],
      name_company: [''],
      nik: [''],
      position: [''],
      card_id: [''],
      document_partner: [''],
      document_company: [''],
  }, {
      validator: MustMatch('pass', 'repass')
  });
  submitted = false;
  loading = false;
  loadingform = false;
  registersuccess=false;
  inpuCardid:any = "";
  inputPks:any = "";
  inputDocumentcompany:any = "";


  Action(){
    //this.showDetail = !this.showDetail;
     console.log('bisa dong');
  }

  ngOnInit() {

   // this.myredirect('https://www.mncplay.id/info-referral');
    
    // this.MyForm = this.formBuilder.group({
    //         // name: [{value:'',disabled:true}, Validators.required],
    //         name: [{value:'',disabled:true}, Validators.required],
    //         sgsmembertype: ['', Validators.required],
    //         customerid: [''],
    //         pass: [{value:'',disabled:true}, [Validators.required,Validators.minLength(6)]],
    //         username: [{value:'',disabled:true}, Validators.required ],
    //         repass: [{value:'',disabled:true}, Validators.required ],
    //         email: [{value:'',disabled:true}, [Validators.required,Validators.email]],
    //         // phonenumber: [{value:'',disabled:true}, [Validators .required,Validators.minLength(10),Validators.pattern('^[0-9]*$')]],
    //         phonenumber: [{value:'',disabled:true}, [Validators .required,Validators.minLength(10),Validators.pattern('^[0-9]*$')]],
    //         description: [''],
    //         name_company: [''],
    //         nik: [''],
    //         position: [''],
    //         card_id: [''],
    //         document_partner: [''],
    //         document_company: [''],
    //     }, {
    //         validator: MustMatch('pass', 'repass')
    //     });
    this.disableform()

  }

  disableform(){

    this.MyForm.get('username').setValue('')
    this.MyForm.get('email').setValue('')
    this.MyForm.get('pass').setValue('')
    this.MyForm.get('repass').setValue('')
    this.MyForm.get('name').setValue('')
    this.MyForm.get('phonenumber').setValue('')
    this.MyForm.get('username').disable()
    this.MyForm.get('email').disable()
    this.MyForm.get('pass').disable()
    this.MyForm.get('repass').disable()
    this.MyForm.get('name').disable()
    this.MyForm.get('phonenumber').disable()

  }
  enableform(){

    this.MyForm.get('username').setValue('')
    this.MyForm.get('email').setValue('')
    this.MyForm.get('pass').setValue('')
    this.MyForm.get('repass').setValue('')
    this.MyForm.get('name').setValue('')
    this.MyForm.get('phonenumber').setValue('')
    this.MyForm.get('username').enable()
    this.MyForm.get('email').enable()
    this.MyForm.get('pass').enable()
    this.MyForm.get('repass').enable()
    this.MyForm.get('name').enable()
    this.MyForm.get('phonenumber').enable()

  }


get f() { return this.MyForm.controls; }

pickmembertype(event:any){
  //this.membertype = this.value;
  //alert();
  // console.log(this.MyForm.value['sgsmembertype']);
  if(event.target.value == 2){
    console.log(event.target.value);
    // this.ismembertypevalid = true;
    // this.MyForm.get('name').enabled
    this.enableform()

    // = this.formBuilder.group({
    //   // name: [{value:'',disabled:true}, Validators.required],
    //   name: [{value:'',disabled:false}, Validators.required],})
  }else{
    //this.disableform()
  }
  //console.log(this.f.sgsmembertype.setErrors({ return: _pr['username'] }));

}

onCustomerKey(e)
{
  console.log(e);
  this.byCustomer();
}

ismembertypevalidx(){
  console.log('x');
  this.MyForm.controls['fullname'].disable();

}

byCustomer()
{
  let custid = this.MyForm.value['customerid'];
  if ( custid == undefined || custid == ''){
    this.f.customerid.setErrors({ req: 'ID Pelanggan harus diisi' });
    return;
  }

  return this.ApiSgsService.searchCustomer({id:custid}).subscribe((output: any) => {
      console.log(output);   
      if (output.status == true){
        //this.registersuccess = true;
        this.ismembertypevalid = true;
        // this.MyForm.controls['name'].enable();
        // this.MyForm.controls['name'].setValue(output.data['nama']);
        // this.MyForm.controls['pass'].enable();
        // this.MyForm.controls['repass'].enable();
        // this.MyForm.controls['username'].enable();
        // this.MyForm.controls['email'].enable();
        // this.MyForm.controls['phonenumber'].enable();

        this.enableform();
        setTimeout(() => {
          this.MyForm.get('name').setValue(output.data['nama'])
          this.MyForm.get('phonenumber').setValue(output.data['selular1'])
        }, 500);


      }else{
        this.ismembertypevalid = false;
        // this.MyForm.controls['name'].setValue('');
        // this.MyForm.controls['name'].disable();

        // this.MyForm.controls['pass'].setValue('');
        // this.MyForm.controls['pass'].disable();

        // this.MyForm.controls['repass'].setValue('');
        // this.MyForm.controls['repass'].disable();

        // this.MyForm.controls['username'].setValue('');
        // this.MyForm.controls['username'].disable();
        // this.MyForm.controls['email'].setValue('');
        // this.MyForm.controls['email'].disable();
        // this.MyForm.controls['phonenumber'].setValue('');
        // this.MyForm.controls['phonenumber'].disable();
        this.disableform();
        this.f.customerid.setErrors({ return: 'ID Pelanggan tidak valid '});
        
      }                          
      //this.Prospectsgs = output.data;
    })
  //return false;
}


changeBase64($event:any) {
  // this.fileData = <File>$event.target.files[0]
  this.readThis($event.target,"func"+$event.target.id)
}

readThis(inputValue: any, funct:any): void {
  var file:File = inputValue.files[0];
  var myReader:FileReader = new FileReader();

  myReader.readAsDataURL(file);
  myReader.onloadend = (e) => {
    this[funct](myReader.result)
  }
}

funcinpuCardid(base64:any){
  this.inpuCardid = base64;
  // console.log("tea1")
}
funcinputPks(base64:any){
    this.inputPks = base64;
    // console.log("tea2")
}
funcinputDocumentcompany(base64:any){
    this.inputDocumentcompany = base64;
    // console.log("tea3")
}



Submit()
{

  this.submitted = true;
  this.loading = true;
  // stop here if form is invalid
  if (this.MyForm.invalid) {
    //alert('tidak valid');
    //console.log(this.MyForm);
    this.loading = false;
    return;
  }

  
  let data = this.MyForm.value;
  data['fileData'] = [];
  if( data.sgsmembertype == 2 ){
    data['fileData'].push({
      "file": this.inpuCardid,
      "doc_type": 1
    });
    data['fileData'].push({
      "file": this.inputPks,
      "doc_type": 2
    });
    data['fileData'].push({
      "file": this.inputDocumentcompany,
      "doc_type": 3
    });
  }
  //console.log(data);
  
  return this.ApiSgsService.postNewmember(data).subscribe((output: any) => {
      console.log(output);   
      if (output.status){
        this.loading = false;
        this.registersuccess = true;
      }else{
        let _pr = JSON.parse(output.message);
        
        if (_pr['email']){
          this.MyForm.controls['email'].setErrors({ return: _pr['email'] });
        }
        if (_pr['username']){
          this.MyForm.controls['username'].setErrors({ return: _pr['username'] });
        }

        this.loading = false;
        
      }                          
      //this.Prospectsgs = output.data;
    })
  // //return false;
}



  submits()
  {

    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.MyForm.invalid) {
        this.loading = false;
        return;
    }

    let data = this.MyForm.value;
     console.log(data);

     /*
    return this.api.AddTeam(data).subscribe((output: {}) => {
      console.log(output);
      this.loading = false;
      this.router.navigate(['/admin/team']);
      
    }) */
  }

  myredirect(url){
    this.loadingform = true;
    this.router.ngOnDestroy();
    window.location.href = url;
  }

}
